import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-textb",
  "use": "icon-th-textb-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-textb\">\n<path d=\"M21.31 14.4625C22.0999 13.7022 22.6445 12.7231 22.8739 11.651C23.1034 10.5789 23.0072 9.46275 22.5977 8.44573C22.1882 7.42872 21.4841 6.55729 20.5758 5.94332C19.6675 5.32934 18.5964 5.00085 17.5 5H9C8.73478 5 8.48043 5.10536 8.29289 5.29289C8.10536 5.48043 8 5.73478 8 6V25C8 25.2652 8.10536 25.5196 8.29289 25.7071C8.48043 25.8946 8.73478 26 9 26H19C20.3868 26 21.7309 25.5196 22.8035 24.6404C23.876 23.7613 24.611 22.5378 24.8832 21.1779C25.1555 19.8181 24.9483 18.4059 24.2968 17.1816C23.6454 15.9573 22.5899 14.9964 21.31 14.4625ZM10 7H17.5C18.4283 7 19.3185 7.36875 19.9749 8.02513C20.6313 8.6815 21 9.57174 21 10.5C21 11.4283 20.6313 12.3185 19.9749 12.9749C19.3185 13.6313 18.4283 14 17.5 14H10V7ZM19 24H10V16H19C20.0609 16 21.0783 16.4214 21.8284 17.1716C22.5786 17.9217 23 18.9391 23 20C23 21.0609 22.5786 22.0783 21.8284 22.8284C21.0783 23.5786 20.0609 24 19 24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-textb.svg
// module id = jH1O
// module chunks = 84